import { FunctionComponent } from "react";

/**
 * Trailing filter-bar caption: how many leads the current Outbox scope matched
 * (the backend count query caps at 1000, rendered as "1000+").
 */
export const OutboxLeadCountLabel: FunctionComponent<{ count: number }> = ({ count }) => (
	<span className="text-text-meta text-xs whitespace-nowrap">
		{count > 0 ? (
			<>
				<span className="font-bold">
					{`${count > 1 ? (count === 1000 ? "1000+ leads are" : `${count} leads are`) : `${count} lead is`}`}{" "}
				</span>
				successfully selected!
			</>
		) : (
			<span>
				<span className="font-bold"> No leads </span> are selected!
			</span>
		)}
	</span>
);
